import { Navigate, Outlet } from "react-router";
import useUserStore from "../../store/useUserStore";

const ProtectedRoute = ({ permission }) => {
  const { isAuthenticated = false, permissions = null } = useUserStore();

  if (permission && isAuthenticated) {
    return permissions && permissions[permission] === true ? (
      <Outlet />
    ) : (
      <Navigate to="/auctions" />
    );
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/auctions" />;
};

export default ProtectedRoute;
